// Textos del sitio en español (es) e inglés (en). Las dos versiones deben tener las mismas claves.
// Datos con textos propios: projects.js, team.js y gallery.js (cada uno con es/en).
const translations = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      about: "Quiénes somos",
      projects: "Proyectos",
      gallery: "Galería",
      contact: "Contacto",
      cta: "Agendá una reunión",
      mainNav: "Navegación principal",
      toggleLanguage: "Cambiar idioma a inglés",
      openMenu: "Abrir menú",
      closeMenu: "Cerrar menú",
    },
    hero: {
      titleLine1: "Soluciones basadas",
      titleLine2: "en la naturaleza.",
      intro1: "Asesoramos a personas, empresas, instituciones y comunidades en la implementación de estrategias sostenibles que generan valor ambiental, social y económico.",
      intro2: "Ayudamos a cumplir indicadores, pero más allá de eso impulsamos proyectos de los que las personas quieran formar parte.",
      ctaPrimary: "Conocé nuestros servicios",
      ctaSecondary: "Ver proyectos",
      stats: ["Años de experiencia", "Personas abordadas", "Países"],
      slides: ["Talleres comunitarios", "Educación en campo", "Ciencia ciudadana", "Diagnósticos empresariales y organizacionales"],
      tagline: "Impulsando soluciones basadas en la naturaleza",
      explore: "Explorar",
      goToSlide: "Ir a la foto",
    },
    about: {
      title: "Quiénes somos",
      description: "Somos un equipo interdisciplinario comprometido con la sostenibilidad. Diseñamos e implementamos soluciones integrales e innovadoras que generan impacto ambiental y social. Integramos asesoría técnica, creatividad y optimización de recursos para desarrollar proyectos estratégicos que fortalecen la educación ambiental y la vinculación comunitaria como motores de cambio. Acompañamos a empresas y comunidades en la transición hacia modelos más sostenibles y regenerativos, alineados con los Objetivos de Desarrollo Sostenible (ODS). Convertimos la sostenibilidad en decisiones concretas y resultados medibles, relevantes y transformadores.",
      quote1: "Creemos profundamente que la educación ambiental solo transforma cuando despierta curiosidad, emoción y sentido de pertenencia.",
      quote2: "Lo que más disfrutamos es encontrar el punto donde la ciencia, la educación creativa y la estrategia generan cambios que permanecen en el tiempo.",
      logoAlt: "Savia — Asesorías en Sostenibilidad",
      teamTitle: "Nuestro equipo",
      viewProfile: "Ver perfil completo",
      closeProfile: "Cerrar perfil",
    },
    services: {
      badge: "Nuestros servicios",
      titleLine1: "Soluciones integrales a medida para",
      description1: "Asesoramos en el cumplimiento de estándares de sostenibilidad.",
      description2: "Impulsamos cambios de comportamiento hacia prácticas más sostenibles y la integración multisectorial, creando sinergias para mejorar el entorno productivo y de las comunidades.",
      description3: "Brindamos asesoría técnica para la formulación de políticas, normativas y planificación a nivel nacional y local.",
      wordPairs: [
        "Empresas, Instituciones",
        "Personas, Organizaciones",
        "Comunidades, Instituciones",
        "Personas, Comunidades",
        "Organizaciones, Empresas",
      ],
      cards: [
        {
          title: "Gestión de Residuos y Economía Circular",
          bullets: [
            "Planes de manejo de residuos sólidos y líquidos a nivel empresarial, institucional y para eventos.",
            "Estrategias hacia basura cero, reducción, reutilización y reciclaje a nivel empresarial y comunitario.",
            "Diseño de procesos basados en principios de circularidad y reducción de huella hídrica y de carbono.",
          ],
        },
        {
          title: "Diagnósticos y Estrategias de Sostenibilidad",
          bullets: [
            "Evaluaciones de huella de carbono y agua.",
            "Asesoría y acompañamiento para auditorías de sostenibilidad.",
            "Planes de acción para la descarbonización y metas de emisiones netas cero.",
          ],
        },
        {
          title: "Educación para el Desarrollo Sostenible",
          bullets: [
            "Charlas y talleres sobre consumo responsable, gestión de residuos, vida silvestre, gestión del recurso hídrico, cambio climático y descarbonización, agroecología, entre otros.",
            "Diseño, planificación y ejecución de actividades de sensibilización ambiental (festivales, actividades lúdicas y artísticas, limpiezas responsables de espacios públicos, entre otras).",
            "Diseño, implementación y evaluación de programas y proyectos educativos.",
          ],
        },
        {
          title: "Interpretación Ambiental",
          bullets: [
            "Interpretación de senderos y señalización en fincas y proyectos ecoturísticos.",
            "Inventarios de biodiversidad realizados de forma personalizada o participativa mediante procesos de ciencia ciudadana.",
            "Elaboración de materiales didácticos y de comunicación estratégica.",
          ],
        },
      ],
      carousel: "carrusel",
      prev: "Servicio anterior",
      next: "Servicio siguiente",
      goTo: "Ir al servicio",
    },
    projects: {
      title: "Proyectos y actividades",
      currentTitle: "Proyectos en curso",
      currentIntro: "Estos son algunos de los proyectos y actividades en los que SAVIA está participando.",
      pastTitle: "Trayectoria de nuestro equipo",
      pastIntro: "Antes de SAVIA, nuestra experiencia se construyó liderando y coordinando proyectos junto a organizaciones, instituciones, empresas y comunidades. Esta es la trayectoria que respalda nuestro trabajo.",
      seeMore: "Ver más",
      seeLess: "Ver menos",
      fields: {
        project: "Proyecto",
        results: "Resultados",
        actors: "Actores",
        implementation: "Implementación",
        partners: "Socios estratégicos",
      },
    },
    gallery: {
      badge: "Galería",
      title: "Nuestro trabajo en imágenes",
      categories: ["Todos", "Asesorías", "Procesos comunitarios", "Actividades de campo", "Metodologías y materiales", "Ciencia ciudadana", "Interpretación ambiental"],
      photoCredit: "Foto",
    },
    contact: {
      badge: "Conversemos",
      title: "Comenzá a impulsar tus soluciones hoy",
      namePlaceholder: "Nombre completo",
      companyPlaceholder: "Empresa / Organización",
      emailPlaceholder: "Correo electrónico",
      phonePlaceholder: "Teléfono (opcional)",
      messagePlaceholder: "Contanos sobre tu proyecto o necesidad...",
      consent: "Acepto recibir información sobre servicios de SAVIA",
      submit: "Agendá una reunión",
      sending: "Enviando...",
      successTitle: "Mensaje enviado con éxito",
      successMessage: "Nos pondremos en contacto con vos pronto.",
      errorTitle: "No pudimos enviar tu mensaje.",
      errorMessage: "Intentá de nuevo en unos minutos o escribinos por",
      errors: {
        required: "Este campo es obligatorio.",
        email: "Ingresá un correo electrónico válido.",
        messageMin: "Escribí al menos 20 caracteres.",
      },
      info: {
        title: "Información de contacto",
        location: "Costa Rica",
      },
    },
    footer: {
      description: "Firma costarricense de asesoría en sostenibilidad: soluciones basadas en la naturaleza para personas, empresas, instituciones y comunidades.",
      servicesTitle: "Servicios",
      services: ["Diagnóstico Ambiental", "Estrategia de Sostenibilidad", "Certificaciones Ambientales", "Capacitación y Cultura"],
      companyTitle: "Empresa",
      aboutUs: "Nosotros",
      ourProjects: "Proyectos",
      ourTeam: "Equipo",
      contactTitle: "Contacto",
      whatsapp: "Escribir por WhatsApp",
      rights: "Todos los derechos reservados.",
      developedBy: "Sitio desarrollado por",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About us",
      projects: "Projects",
      gallery: "Gallery",
      contact: "Contact",
      cta: "Schedule a meeting",
      mainNav: "Main navigation",
      toggleLanguage: "Switch language to Spanish",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    hero: {
      titleLine1: "Nature-based",
      titleLine2: "solutions.",
      intro1: "We advise people, businesses, institutions and communities on implementing sustainable strategies that create environmental, social and economic value.",
      intro2: "We help meet targets, but beyond that, we drive projects that people want to be part of.",
      ctaPrimary: "Explore our services",
      ctaSecondary: "View projects",
      stats: ["Years of experience", "People reached", "Countries"],
      slides: ["Community workshops", "Field education", "Citizen science", "Business and organizational assessments"],
      tagline: "Empowering nature-wise solutions",
      explore: "Explore",
      goToSlide: "Go to photo",
    },
    about: {
      title: "Who we are",
      description: "We are an interdisciplinary team committed to sustainability. We design and implement comprehensive, innovative solutions that create environmental and social impact. We combine technical expertise, creativity and resource optimization to develop strategic projects that strengthen environmental education and community engagement as drivers of change. We support businesses and communities in their transition toward more sustainable and regenerative models, aligned with the Sustainable Development Goals (SDGs). We turn sustainability into concrete decisions and measurable, relevant and transformative results.",
      quote1: "We deeply believe that environmental education only transforms when it sparks curiosity, emotion and a sense of belonging.",
      quote2: "What we enjoy most is finding the point where science, creative education and strategy create changes that last over time.",
      logoAlt: "Savia — Sustainability Advisors",
      teamTitle: "Our team",
      viewProfile: "View full profile",
      closeProfile: "Close profile",
    },
    services: {
      badge: "Our services",
      titleLine1: "Comprehensive, tailored solutions for",
      description1: "We advise on meeting sustainability standards.",
      description2: "We drive behavior change toward more sustainable practices and multisector integration, creating synergies to improve productive environments and communities.",
      description3: "We provide technical guidance for developing policy, regulation and planning at the national and local levels.",
      wordPairs: [
        "Businesses, Institutions",
        "People, Organizations",
        "Communities, Institutions",
        "People, Communities",
        "Organizations, Businesses",
      ],
      cards: [
        {
          title: "Waste Management and Circular Economy",
          bullets: [
            "Solid and liquid waste management plans for businesses, institutions and events.",
            "Zero-waste strategies: reduction, reuse and recycling at the business and community levels.",
            "Process design based on circularity principles and reduced water and carbon footprints.",
          ],
        },
        {
          title: "Sustainability Assessments and Strategies",
          bullets: [
            "Carbon and water footprint assessments.",
            "Advice and support for sustainability audits.",
            "Action plans for decarbonization and net-zero emissions targets.",
          ],
        },
        {
          title: "Education for Sustainable Development",
          bullets: [
            "Talks and workshops on responsible consumption, waste management, wildlife, water resource management, climate change and decarbonization, agroecology and more.",
            "Design, planning and delivery of environmental awareness activities (festivals, artistic and recreational activities, responsible clean-ups of public spaces, and more).",
            "Design, implementation and evaluation of educational programs and projects.",
          ],
        },
        {
          title: "Environmental Interpretation",
          bullets: [
            "Interpretive trails and signage for farms and ecotourism projects.",
            "Biodiversity inventories carried out in a personalized or participatory way through citizen science.",
            "Development of educational and strategic communication materials.",
          ],
        },
      ],
      carousel: "carousel",
      prev: "Previous service",
      next: "Next service",
      goTo: "Go to service",
    },
    projects: {
      title: "Projects and activities",
      currentTitle: "Current projects",
      currentIntro: "These are some of the projects and activities SAVIA is currently involved in.",
      pastTitle: "Our team's track record",
      pastIntro: "Before SAVIA, our experience was built by leading and coordinating projects alongside organizations, institutions, businesses and communities. This is the track record behind our work.",
      seeMore: "See more",
      seeLess: "See less",
      fields: {
        project: "Project",
        results: "Results",
        actors: "Stakeholders",
        implementation: "Implementation",
        partners: "Strategic partners",
      },
    },
    gallery: {
      badge: "Gallery",
      title: "Our work in images",
      categories: ["All", "Advisory", "Community processes", "Field activities", "Methods and materials", "Citizen science", "Environmental interpretation"],
      photoCredit: "Photo",
    },
    contact: {
      badge: "Let's talk",
      title: "Start driving your solutions today",
      namePlaceholder: "Full name",
      companyPlaceholder: "Company / Organization",
      emailPlaceholder: "Email",
      phonePlaceholder: "Phone (optional)",
      messagePlaceholder: "Tell us about your project or needs...",
      consent: "I agree to receive information about SAVIA's services",
      submit: "Schedule a meeting",
      sending: "Sending...",
      successTitle: "Message sent successfully",
      successMessage: "We'll be in touch soon.",
      errorTitle: "We couldn't send your message.",
      errorMessage: "Please try again in a few minutes or reach us on",
      errors: {
        required: "This field is required.",
        email: "Please enter a valid email address.",
        messageMin: "Please write at least 20 characters.",
      },
      info: {
        title: "Contact information",
        location: "Costa Rica",
      },
    },
    footer: {
      description: "Costa Rican sustainability advisory firm: nature-based solutions for people, businesses, institutions and communities.",
      servicesTitle: "Services",
      services: ["Environmental Assessment", "Sustainability Strategy", "Environmental Certifications", "Training and Culture"],
      companyTitle: "Company",
      aboutUs: "About us",
      ourProjects: "Projects",
      ourTeam: "Team",
      contactTitle: "Contact",
      whatsapp: "Chat on WhatsApp",
      rights: "All rights reserved.",
      developedBy: "Website by",
    },
  },
};

export default translations;
